import React from 'react';
import classNames from 'classnames/bind';
import { string as stringProp } from 'prop-types';
import { params, string, shape, useDataModel } from '@thd-nucleus/data-sources';
import { DUAL_PATH_IDENTIFIER } from '../../constants';
import styles from './product-service-add-ons.module.scss';

const cx = classNames.bind(styles);

export const ProductServiceAddOns = ({ itemId }) => {
  const { data } = useDataModel('product', {
    variables: {
      itemId,
    }
  });
  const product = data?.product || {};

  const isDualPathSku = product?.info?.productSubType?.name === DUAL_PATH_IDENTIFIER;

  return isDualPathSku ? (
    <div className={cx('product-service-adds-on__service-message')}>
      Expert Installation Available
    </div>
  ) : null;
};
ProductServiceAddOns.propTypes = {
  itemId: stringProp.isRequired,
};

ProductServiceAddOns.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      productSubType: shape({
        name: string(),
      }),
    }),
  }),
};

ProductServiceAddOns.displayName = 'ProductServiceAddOns';
